/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

export const onClientEntry = () => {
  // Load Google Analytics (GA4)
  const script1 = document.createElement("script");
  script1.async = true;
  script1.src = "https://www.googletagmanager.com/gtag/js?id=G-YBR80ZPFKG";
  document.head.appendChild(script1);

  // Initialize GA
  const script2 = document.createElement("script");
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-YBR80ZPFKG', {
      anonymize_ip: true
    });
  `;
  document.head.appendChild(script2);
};
